import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function SearchBarItem(props) {
  var className = props.className,
    label = props.label,
    onClick = props.onClick,
    content = props.content,
    children = props.children,
    hasInput = props.hasInput;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item ".concat(className, " ").concat(hasInput ? 'has-input' : ''),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item-label"
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-content"
  }, content || children));
}
SearchBarItem.defaultProps = {
  className: '',
  content: '',
  children: '',
  hasInput: false
};
SearchBarItem.propTypes = {
  className: PropTypes.string,
  label: nodeOrStringProp.isRequired,
  onClick: PropTypes.func.isRequired,
  content: nodeOrStringProp,
  children: nodeOrStringProp,
  hasInput: PropTypes.bool
};

export default SearchBarItem;
